export const SET_SYSTEM_EMAILS_LIST = 'systemEmails/SET_SYSTEM_EMAILS_LIST'
export const SET_MANAGE_SYSTEM_EMAIL = 'systemEmails/SET_MANAGE_SYSTEM_EMAIL'
export const UPDATE_ACTIVE_SYSTEM_EMAIL = 'systemEmails/UPDATE_ACTIVE_SYSTEM_EMAIL'
